import styled from 'styled-components'

import { useModal } from '@/app/providers/ModalProvider'
import useLockBodyScroll from '@/shared/hooks/useLockScroll'
import { Nanum_r_size, Nanum_rb_size } from '@/styles/font/NanumSquare'
import { mediaTablet } from '@/styles/mediaQuery'

const Modal = () => {
  const { isOpen, modalData, closeModal } = useModal()
  const { contents, buttons, styles } = modalData

  useLockBodyScroll(isOpen)

  if (!isOpen) return null

  const handleClickCancel = () => {
    buttons?.cancel?.func?.()
    if (buttons?.cancel?.close !== false) {
      closeModal()
    }
  }

  const handleClickSubmit = () => {
    buttons?.submit?.func?.()
    if (buttons?.submit?.close !== false) {
      closeModal()
    }
  }
  return (
    <ModalBackdrop>
      <ModalWrap onClick={(e) => e.stopPropagation()}>
        {contents?.title && <Title>{contents.title}</Title>}
        {contents?.desc && (
          <Description
            dangerouslySetInnerHTML={{ __html: contents.desc }}
            $fontSize={styles?.desc?.fontSize}
            $textAlign={styles?.desc?.textAlign}
            $bgColor={styles?.desc?.bgColor}
          />
        )}

        {contents?.children}
        <ButtonGroup>
          {buttons?.cancel && (
            <CancelButton onClick={handleClickCancel}>{buttons.cancel.text}</CancelButton>
          )}
          {buttons?.submit && (
            <SubmitButton onClick={handleClickSubmit}>{buttons.submit.text}</SubmitButton>
          )}
        </ButtonGroup>
      </ModalWrap>
    </ModalBackdrop>
  )
}

export default Modal

const ModalBackdrop = styled.div`
  z-index: 100;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`

const ModalWrap = styled.div`
  width: 90%;
  z-index: 500;
  border-radius: 10px;
  max-width: 492px;
  padding: 34px 24px;
  background-color: var(--white);
  color: var(--blue-2);
`
export const Title = styled.h4`
  ${Nanum_rb_size(18)}
  text-align: center;
  margin-bottom: 26px;

  ${mediaTablet} {
    margin-bottom: 21px;
  }
`
export const Description = styled.p<{
  $fontSize?: number
  $textAlign?: 'left' | 'center' | 'right'
  $bgColor?: string
}>`
  ${({ $fontSize }) => Nanum_r_size($fontSize ?? 16)}
  text-align: ${({ $textAlign }) => $textAlign ?? 'center'};
  line-height: 1.4;
  white-space: pre-line;
  margin-bottom: 32px;
  background-color: ${({ $bgColor }) => $bgColor ?? 'transparent'};
  padding: ${({ $bgColor }) => ($bgColor ? '20px' : '0')};
  border-radius: ${({ $bgColor }) => ($bgColor ? '10px' : '0')};

  ${mediaTablet} {
    ${({ $fontSize }) => Nanum_r_size($fontSize ?? 14)}
    line-height: 1.4;
    margin-bottom: 20px;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  color: var(--white);
`
const CancelButton = styled.button`
  ${Nanum_rb_size(14)}
  padding: 12px 35px;
  background-color: var(--gray-7a);
  border-radius: 5px;
`
const SubmitButton = styled.button`
  ${Nanum_rb_size(14)}
  border-radius: 5px;
  padding: 12px 35px;
  background-color: var(--green);
`
